import React, { useEffect, useState } from 'react';
import { Button, Col, Input, Row, Form, FormGroup, Label } from 'reactstrap';
import { validateWholeNumber, validateEmail, validatePhoneNumber } from 'utils/functions';

const NewUser = ({ resetForm, setResetForm, createAdminUser }) => {
  const defaultState = {
    name: '',
    phone: '',
    email: '',
    username: '',
    permissions: '',
    enabled: true,
  };

  const [formData, setFormData] = useState(defaultState);

  const [errors, setErrors] = useState({
    phone: '',
    email: '',
    permissions: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Validation
    if (name === 'phone') {
      setErrors({ ...errors, phone: validatePhoneNumber(value) ? '' : 'Invalid phone number' });
    }
    if (name === 'email') {
      setErrors({ ...errors, email: validateEmail(value) ? '' : 'Invalid email format' });
    }
    if (name === 'permissions') {
      setErrors({ ...errors, permissions: validateWholeNumber(value) ? '' : 'Must be a whole number' });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.phone || !formData.email || !formData.username) {
      alert('All fields are required.');
      return;
    }

    if (errors.phone || errors.email || errors.permissions) {
      alert('Please fix validation errors before submitting.');
      return;
    }

    createAdminUser(formData);
  };

  useEffect(() => {
    if (resetForm) {
      setFormData(defaultState);
      setResetForm(false);
    }
  }, [resetForm]);

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col>
          <h5 className="section-heading">Create New User</h5>
        </Col>
      </Row>

      <Row className="info-row">
        <Col lg="6" md="6">
          <FormGroup>
            <Label>Name</Label>
            <Input type="text" name="name" value={formData.name} onChange={handleChange} required />
          </FormGroup>
        </Col>

        <Col lg="6" md="6">
          <FormGroup>
            <Label>Phone</Label>
            <Input type="text" name="phone" value={formData.phone} onChange={handleChange} required />
            {errors.phone && <small className="text-danger">{errors.phone}</small>}
          </FormGroup>
        </Col>
      </Row>

      <Row className="info-row">
        <Col lg="6" md="6">
          <FormGroup>
            <Label>Email</Label>
            <Input type="email" name="email" value={formData.email} onChange={handleChange} required />
            {errors.email && <small className="text-danger">{errors.email}</small>}
          </FormGroup>
        </Col>

        <Col lg="6" md="6">
          <FormGroup>
            <Label>Username</Label>
            <Input type="text" name="username" value={formData.username} onChange={handleChange} required />
          </FormGroup>
        </Col>
      </Row>

      <Row className="info-row">
        <Col lg="6" md="6">
          <FormGroup>
            <Label>Permissions</Label>
            <Input type="text" name="permissions" value={formData.permissions} onChange={handleChange} />
            {errors.permissions && <small className="text-danger">{errors.permissions}</small>}
          </FormGroup>
        </Col>

        <Col lg="6" md="6">
          <FormGroup>
            <Label>Status</Label>
            <Input type="select" name="enabled" value={formData.enabled} onChange={handleChange}>
              <option value={true}>Active</option>
              <option value={false}>Disabled</option>
            </Input>
          </FormGroup>
        </Col>
      </Row>

      <Row className="info-row">
        <Col md="12" style={{ textAlign: "right" }}>
          <Button color="primary" type="submit">Create User</Button>
        </Col>
      </Row>
    </Form>
  );
};

export default NewUser;
